export const getAreaOptions = (store) => {
  const areas = store.area.areas;

  return areas.map((item) => ({ value: item._id, label: item.name }));
};
